function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import fetchClient from "../fetch";
import { log } from "../logger";
import { getCorrelationId } from "../logger/utils";
var canUseDOM = typeof document !== "undefined";
var logErrorsAndReturn = function(result, correlationId, errorData) {
    if (result.errors) {
        // Get the first error message, and append to the log error to differentiate errors coming into Sentry.
        var message = result.errors[0].message;
        log.error("GraphQLError: " + message, _extends({
            error: result.errors
        }, errorData, {
            correlationId: correlationId
        }));
    }
    return result;
};
var createHeaders = /*#__PURE__*/ _async_to_generator(function(param) {
    var appendHeaders, req, getSecret, _param_secretValue, secretValue, _param_userAgent, userAgent, headers, _;
    return _ts_generator(this, function(_state) {
        switch(_state.label){
            case 0:
                appendHeaders = param.appendHeaders, req = param.req, getSecret = param.getSecret, _param_secretValue = param.secretValue, secretValue = _param_secretValue === void 0 ? "akamai-token" : _param_secretValue, _param_userAgent = param.userAgent, userAgent = _param_userAgent === void 0 ? "lululemon/mwa-graph" : _param_userAgent;
                headers = _extends({}, appendHeaders, {
                    "Content-Type": "application/json"
                });
                headers["x-lll-ecom-correlation-id"] = getCorrelationId(req);
                if (!req) return [
                    3,
                    2
                ];
                headers["x-forwarded-for"] = req.headers["x-forwarded-for"];
                headers.referer = req.headers.referer;
                // Setting this header disables the rule that akamai requires a locale cookie to be set.
                // Please do not remove as without this all requests from SEO crawler bots will fail when hitting the graphql endpoint
                headers.Accept = "application/json";
                headers["User-Agent"] = userAgent;
                if (req.headers.cookie) {
                    headers.Cookie = req.headers.cookie;
                }
                if (!getSecret) return [
                    3,
                    2
                ];
                _ = "x-lll-access-token";
                return [
                    4,
                    getSecret(secretValue)
                ];
            case 1:
                headers[_] = _state.sent();
                _state.label = 2;
            case 2:
                return [
                    2,
                    headers
                ];
        }
    });
});
var graphClient = function(param) {
    var _ref = param === void 0 ? {} : param, req = _ref.req, res = _ref.res;
    for(var _len = arguments.length, middleware = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        middleware[_key - 1] = arguments[_key];
    }
    // instantiate fetchClient with middlewares, if any
    var fetch = fetchClient.apply(void 0, [
        req
    ].concat(_to_consumable_array(middleware)));
    var correlationId = getCorrelationId(req);
    // return the actual query agent
    return /*#__PURE__*/ _async_to_generator(function(param) {
        var query, variables, url, appendHeaders, getSecret, errorData, secretValue, userAgent, headers, response, err, connectionError, requestError;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, variables = param.variables, url = param.url, appendHeaders = param.appendHeaders, getSecret = param.getSecret, errorData = param.errorData, secretValue = param.secretValue, userAgent = param.userAgent;
                    return [
                        4,
                        createHeaders({
                            appendHeaders: appendHeaders,
                            req: req,
                            getSecret: getSecret,
                            secretValue: secretValue,
                            userAgent: userAgent
                        })
                    ];
                case 1:
                    headers = _state.sent();
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        fetch(url, {
                            method: "POST",
                            credentials: "include",
                            headers: headers,
                            body: JSON.stringify({
                                query: query,
                                variables: variables
                            })
                        })
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        3,
                        5
                    ];
                case 4:
                    err = _state.sent();
                    connectionError = new Error("Could not connect to GraphQL API at " + url);
                    connectionError.response = err;
                    throw connectionError;
                case 5:
                    if (response.ok) {
                        if (res && !canUseDOM) {
                            res.set("set-cookie", response.headers.raw()["set-cookie"]);
                        }
                        return [
                            2,
                            response.json().then(function(result) {
                                return logErrorsAndReturn(result, correlationId, errorData);
                            })
                        ];
                    }
                    if (response.json) {
                        return [
                            2,
                            response.json().then(function(result) {
                                return logErrorsAndReturn(result, correlationId, errorData);
                            })
                        ];
                    }
                    requestError = new Error(response.statusText);
                    requestError.response = response;
                    throw requestError;
            }
        });
    });
};
export default graphClient;
